<template>
  <div class="body">
    <div class="form-header" >
      <!-- <strong>{{ areaList[fid] }}</strong> -->
      <!-- <div class="desc"><van-button class="btn-desc" type="info" size="mini" round @click="showDesc">活动说明</van-button></div> -->
    </div>
    <div class="loading" v-if="loading"><van-loading style="position: absolute;left:50%;right:50%;top: 50%;" type="spinner" /></div>
    <div class="list" v-if="!loading && auth">
      <div class="add">
        <van-button class="btn" round  @click="newForm"></van-button>
      </div>
      <van-tabs v-model="activeTab">
        <van-tab title="填报记录" name="1">
          <ListComponent :refresh="refresh" :status="0" :active="activeTab" :ffid="fid" :car-modify="false"  @refreshed="refresh = false"/>
        </van-tab>
      </van-tabs>
      
    </div>
    
    <div v-else-if="!loading">
      <img v-if="fid == 1" style="width: 100%;" src="//img.shaoxing.com.cn/a/10001/202402/1051c650e4821671e678b04f93d2a5e6.jpeg" alt="">
      <img v-else-if="fid == 2" style="width: 100%;" src="//img.shaoxing.com.cn/a/10001/202404/f421c85539119cc9aef642360bb1ebd5.jpeg" alt="">
    </div>
  </div>
</template>
<script>
// import Vconsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new Vconsole()
import { mc } from '../../assets/common2.js'
import ListComponent from '@/components/ListComponent.vue'
// import { Loading } from 'vant'
export default {
  name: 'YmwhxjList',
  props: {
  },
  data () {
    return {
      fid: 14,
      activeTab: '1',
      refresh: false,
      auth: false,
      loading: true,
    }
  },
  components: {
    ListComponent

  },
  computed: {
  },
  created: function () {
    if (!mc.isClient()) {
      this.$router.replace('/ymwhxj/index')
      // console.log(1);
      
    } else {
      this.fid = this.$route.params.fid ? this.$route.params.fid : '14'
      this.$store.commit('setFid',this.fid)
      // console.log(vConsole);
      this.auth = true
      this.loading = false
    }
    document.title = '“越知越行”绍兴市首届阳明文化宣讲大赛报名'
  },
  mounted: function () {
    
  },
  methods: {
    newForm() {
      this.refresh = false
      this.$router.push(`/ymwhxj/form/0`)
      
    },
    showDesc() {
      mc.openContentView({
        appid: 1,
        contentid: 3249616,
        siteid: 10001
      })
    }
  },
  watch: {
    $route(to,from) {
      if (from.name == 'RunnerList' && from.name == 'RunnerForm' && this.$store.state.needRefresh) {
        // if (from.params.form_id>0) {
        //   this.activeTab = '2'
        // }
        this.$store.commit('setNeedRefresh',false)
        this.refresh = true
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-header {
  display: block;
  position: sticky;
  top: 0;
  height: 33.75vw;
  max-width: 480px;
  max-height: 162px;
  font-size: 1.1rem;
  /* line-height: 2rem; */
  text-align: left;
  background-color: #44b4cc;
  background-image: url(//res.shaoxing.com.cn/a/10001/202410/b54e196809523ccaf26c311cefe00738.jpg);
  background-size: 100%;
  background-repeat: no-repeat;
}

.loading {
  width: 100%;
  height: 80vh;
}
.add {
  position:absolute;
  bottom: 1.5rem;
  left: 50%;
  z-index: 10;
}
.add .btn {
  /* width: 3.5rem; */
  width: 8rem;
  height: 2.4rem;
  margin: -4rem;
  background-image: url(//res.shaoxing.com.cn/a/10001/202410/518817a4bbf71fd6efb8a83759d0309c.png);
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: unset;
  border: unset;
}
.body .van-tabs__wrap {
  position: sticky;
  top: 16px;
  z-index: 999;
}
.body .van-search {
  position: sticky;
  top: 60px;
  z-index: 999;
}
.body .list {
  height: 60vh;
  background-color: #fff;
}
.btn-desc {
  float: right;
  margin-top: 2rem;
}
</style>
<style>
html,body {
  height: 100%
}

</style>
